import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'

/* eslint-enable no-undef, no-unused-vars, no-empty-pattern */

export const FooterRoot = styled('footer')(({ theme }) => ({
  position: 'relative',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  borderTop: `2px solid ${theme.palette.primary.main}`,
  height: '5rem',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    height: 'auto',
  },
}))

export const FooterText = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  right: '1rem',
  bottom: '1.1rem',
  color: theme.palette.primary.light,
  fontSize: '0.95rem',
  fontWeight: 500,
  fontFamily: theme.typography.fontFamily,
  textAlign: 'right',
  [theme.breakpoints.down('sm')]: {
    right: '0.75rem',
    bottom: '0.35rem',
    fontSize: '0.85rem',
  },
}))

export const FooterLink = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  left: '1rem',
  bottom: '1.1rem',
  color: theme.palette.primary.main,
  fontSize: '0.9rem',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
  [theme.breakpoints.down('sm')]: {
    left: '0.75rem',
    bottom: '0.35rem',
    fontSize: '0.8rem',
  },
}))

export const FooterLogo = styled('img')(({ theme }) => ({
  height: '55%',
  [theme.breakpoints.down('sm')]: {
    position: 'relative',
    width: 'clamp(6rem, 60%, 12rem)',
    height: 'unset',
    marginTop: '1rem',
  },
}))

/* eslint-disable no-undef, no-unused-vars, no-empty-pattern */
